export default function (price: number): string {
  if (typeof price === 'undefined' || price === null) {
    return ''
  }

  if (typeof price === 'number') {
    return `$${price.toFixed(2)}`
  }
  else {
    return `$${price}`
  }
}
